import { decorate, observable, action, runInAction } from 'mobx';
import WebApi, { getErrorMessage, getValidationErrors } from 'modules/WebApi';
//import { StoreInterface, RootStoreInterface } from 'interfaces';
import CommonStore from "modules/CommonStore";
import TariffsAPI from "./api"

class tariffsStore extends CommonStore {

  constructor(rootStore: RootStoreInterface) {
    const apiClient = new TariffsAPI(rootStore.apiClient);

    super(
        rootStore,
        apiClient,
        rootStore.specifications["TariffsGroups"]
    );

    if (!this.specification.fields.some((field) => field.name === "coefficient")) {
        const fieldIndex = this.specification.fields.findIndex((field) => field.name === "priority");
        this.specification.fields.splice(fieldIndex + 1, 0, { name: "coefficient", type: "number" });
    }

    if (!this.specification.columns.add.includes("coefficient")) {
        const columnIndex = this.specification.columns.add.indexOf("priority");
        this.specification.columns.add.splice(columnIndex + 1, 0, "coefficient");
    }

    const coefficientField = this.specification.fields.find((field) => field.name === "coefficient");
    if (coefficientField.decimals === undefined) {
        coefficientField.decimals = 2;
    }
  }



}


decorate(tariffsStore, {

});



export default tariffsStore;
